import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";

@Component({
	selector: "app-image-cropper",
	templateUrl: "./image-cropper.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class ImageCropperComponent implements OnInit, OnDestroy {
	@Input() imageType: string;
	@Output() imageTypeChange = new EventEmitter<string>();

	@Input() venueKey: number;
	@Output() onComplete: EventEmitter<boolean> = new EventEmitter<boolean>();

	imageLoaded: boolean = false;
	cropperSubscription = new Subscription();

	showImageCropper: boolean;

	constructor(public imgCrop: ImageCropperService) {}
	ngOnDestroy(): void {
		this.cropperSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.cropperSubscription.add(
			this.imgCrop.showImageCropperSubscription.subscribe((change) => {
				console.log(change);
				this.showImageCropper = change;
			})
		);
	}

	onImageLoad(event) {
		this.imageLoaded = true;
	}

	async onImageComplete() {
		this.onComplete.emit(true);
	}
}
